import { createApp } from 'vue'
import App from './App.vue'

import AppLoader from '@/lib/AppLoader'
import Common from '@/lib/CommonUtils'

const app = createApp(App)

app.config.globalProperties.$apploader = new AppLoader()
app.config.globalProperties.$common = new Common()

app.mount('#app')
